
import * as storyblokRuntime$kl0KfxdeSzGcyj0qKEOFLJ0rU3pICd84b1ZaYuEv4bI from '/builds/common/airbaltic-com/bt-frontend-nuxt/node_modules/@nuxt/image/dist/runtime/providers/storyblok'
import * as ipxRuntime$hSN5DuIxehZT3SGkuH0TiH0jSjM3FXh9jNvSqyAcuyo from '/builds/common/airbaltic-com/bt-frontend-nuxt/node_modules/@nuxt/image/dist/runtime/providers/ipx'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 768,
    "md": 1024,
    "lg": 1200,
    "xl": 1440,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipx",
  "domains": [
    "app-assets.airbaltic.com",
    "bt-assets.airbaltic.com",
    "bt-web-assets.airbaltic.com"
  ],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": "webp",
  "quality": 80
}

imageOptions.providers = {
  ['storyblok']: { provider: storyblokRuntime$kl0KfxdeSzGcyj0qKEOFLJ0rU3pICd84b1ZaYuEv4bI, defaults: {"baseURL":"https://assets.airbaltic.com"} },
  ['ipx']: { provider: ipxRuntime$hSN5DuIxehZT3SGkuH0TiH0jSjM3FXh9jNvSqyAcuyo, defaults: {"maxAge":86400} }
}
        